import React from 'react';
import localize from '../localize';
import './Disclaimer.css';

export default localize('pages.scores')(({ i18n }) => (
  <div className="centered-content"><em className="disclaimer">{ i18n.t('disclaimer') }</em></div>
));


// WEBPACK FOOTER //
// ./src/components/Disclaimer/index.js